import { handleRequest } from '../../utils/axios';

export const findGPLXPracticalExamAPI = async (data) => {
  const config = {
    url: '/practice-exam/search',
    method: 'POST',
    data
  };
  return handleRequest(config);
};

export const getGPLXPracticalExamByIdAPI = async (id) => {
  const config = {
    url: `/practice-exam/${id}`,
    method: 'GET'
  };
  return handleRequest(config);
};

export const createGPLXPracticalExamAPI = async (data) => {
  const { fileObj, ...others } = data;

  const formData = new FormData();
  formData.append("file", fileObj);
  // eslint-disable-next-line guard-for-in, no-restricted-syntax
  for (const key in others) {
    if (key === 'licenseType')
      formData.append('licenseType.id', others[key].id);
    else
      formData.append(key, others[key]);
  }

  const config = {
    url: '/practice-exam/',
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  };

  return handleRequest(config);
};

export const updateGPLXPracticalExamAPI = async (data) => {
  const config = {
    url: '/practice-exam/',
    method: 'PUT',
    data
  };

  return handleRequest(config);
};

export const processGPLXPracticalExamAPI = async (id) => {
  const config = {
    url: `/practice-exam/process/${id}`,
    method: 'PUT'
  };
  return handleRequest(config);
};

export const deleteGPLXPracticalExamAPI = async (id) => {
  const config = {
    url: `/practice-exam/${id}`,
    method: 'DELETE'
  };
  return handleRequest(config);
};

export const deleteGPLXPracticalExamsAPI = async (ids) => {
  const config = {
    url: `/practice-exam/all/${ids.toString()}`,
    method: 'DELETE'
  };
  return handleRequest(config);
};